<script>
/**
 * @overview 七牛上传组件 - 动画预览
 *
 * @author huojinzhao
 */

export default {
  name: "AppQiniuPreviewAnimation",

  props: {
    src: {
      type: String,
      required: true,
    },
  },

  methods: {
    preview() {
      let src = this.src || '';
      if (src.indexOf('.zip'))src = src.replace('.zip', '/index.html');
      const message = this.$createElement(
        "iframe",
        {
          domProps: {
            src,
          },
          style: {
            width: "1024px",
            height: "576px",
            border: 0,
          },
          key: Math.floor(Math.random() * (10 ** 10)),
        },
      );

      this.$msgbox({
        title: "动画在线预览",
        customClass: "app-qiniu__preview-animation__dialog",
        message,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
  },
};
</script>

<template>
  <div class="app-qiniu__preview-animation">
    <i class="iconfont icon-animation" />
  </div>
</template>

<style lang="postcss">
.app-qiniu__preview-animation {
  display: flex;
  justify-content: center;
  align-items: center;
}

.app-qiniu__preview-animation > .iconfont {
  font-size: 50px;
  color: var(--font-color-secondary);
}

.app-qiniu__preview-animation__dialog {
  width: auto;
}
</style>
